import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { EidButton, WarningModal } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import { Button } from 'components'
import { useQuery } from 'packages/core'
import { useHistory } from 'react-router'
import { useDeleteApplicationRoleDefinition } from 'hooks'

const DeleteRoleDefinition = ({ item, drawerView, ...rest }) => {
    const { t } = useTranslation()
    const [showConfirm, setShowConfirm] = useState(false)

    const query = useQuery()
    const history = useHistory()
    const [deleteRoleDefinition, { isLoading: isDeleting }] =
        useDeleteApplicationRoleDefinition()

    const handleDelete = () => {
        deleteRoleDefinition(item.id).then(() => {
            setShowConfirm(false)
            query.delete('roleDefinitionId')
            history.push(`${history.location.pathname}?${query.toString()}`)
        })
    }

    return (
        <>
            {!drawerView ? (
                <Button.Delete
                    item={item}
                    onClick={() => setShowConfirm(true)}
                    {...rest}
                />
            ) : (
                <Box width="150px" marginLeft={'40px'}>
                    <EidButton.DrawerActionButton
                        fontColor="#ffffff"
                        bgColor="#E40000"
                        width="100%"
                        onClick={() => setShowConfirm(true)}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            height={'12px'}
                            width={'12px'}
                        >
                            <Icon
                                name="DeleteX"
                                fill="#ffffff"
                                color="#ffffff"
                            />
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            marginLeft="10px"
                        >
                            <Typography style={{ color: '#ffffff' }}>
                                {t('Delete')}
                            </Typography>
                        </Box>
                    </EidButton.DrawerActionButton>
                </Box>
            )}
            <WarningModal
                title={`${t('Delete')} ${item?.friendlyName}`}
                description={t('RoleDefinitionDeleteMessage')}
                yesLabel={t('Delete')}
                noLabel={t('Cancel')}
                open={showConfirm}
                cancel={() => setShowConfirm(false)}
                proceeding={isDeleting}
                proceed={handleDelete}
            />
        </>
    )
}

DeleteRoleDefinition.defaultProps = {
    drawerView: false,
}
export default DeleteRoleDefinition
